import type { Article } from '../types'

export const article: Article = {
  meta: {
    slug: 'jak-funguje-last-minute-ubytovani',
    title: 'Jak funguje last-minute ubytování na Mátevolno',
    perex:
      'Volný termín není problém – je to příležitost. Ukazujeme krásná místa, která mají volno v nejbližších dnech, a propojujeme je s lidmi, kteří mají chuť spontánně vyrazit.',
    coverImage: 'https://images.unsplash.com/photo-1542718610-a1d656d1884c?w=1200&q=80&auto=format&fit=crop',
    coverImageAlt: 'Dřevěná chalupa v horách za západu slunce',
    publishedAt: '2026-06-14',
    author: 'Karel Mařík',
    tags: ['last-minute', 'jak to funguje', 'o nás'],
  },
  content: `Mátevolno vzniklo z jednoduché situace, kterou zná skoro každý majitel chaty, chalupy nebo apartmánu. Rezervace se zruší pár dní před příjezdem. V kalendáři zůstane volné místo. Na klasickou propagaci je pozdě. A přitom by někdo jiný rád jel – jen o tom neví.

Právě proto jsme vytvořili místo, kde lidé najdou krásné pobyty, které mají **volno v nejbližších dnech**. Ne za půl roku. Ne po dlouhém hledání. Ale ve chvíli, kdy se jim opravdu hodí někam vyrazit.

## Volný termín není problém. Je to příležitost.

Pro majitele znamená šanci obsadit místo, které by jinak zůstalo prázdné. Pro hosta možnost najít pobyt, se kterým vůbec nepočítal – často za lepší cenu a bez plánování měsíce dopředu.

Naší misí je propojit tyhle dvě situace v jeden jednoduchý moment: **někdo má volno a někde je volno.** Mátevolno má být místo, kde se obě věci potkají.

## Co děláme jinak

Na běžných rezervačních portálech většinou začnete tím, že zadáte lokalitu, termín a počet osob. Pak zjistíte, že většina pěkných míst je obsazená, drahá nebo dostupná až za dlouho.

My na to jdeme obráceně. **Nejdřív ukážeme místa, která mají volno v nejbližších dnech** – a vy si z nich vyberete, co vám dává smysl. Nemusíte zdlouhavě hledat, co by možná mohlo vyjít. Vidíte rovnou nabídky, které jsou aktuální.

## Proč last-minute nemusí znamenat kompromis

Pobyt na poslední chvíli není zbytek, který nikdo nechtěl. Často jde o krásná místa, kde se jen uvolnil termín. Někdo onemocněl, změnil plány nebo nepřijel. Někdy má majitel volné všední dny, které se hůř obsazují klasickou cestou.

Lidé jsou navíc čím dál flexibilnější a při dobré nabídce rádi vyrazí i mimo víkend. Rodiče s malými dětmi zase často nechtějí platit pobyt dlouho dopředu, protože se jim plány můžou kdykoliv změnit. O to víc dává smysl mít místo, kde se aktuálně volné termíny zobrazují rychle a přehledně.

## Pro koho Mátevolno je

Pro každého, kdo má chuť jet, ale nechce plánovat půl roku dopředu. Pro lidi, kteří si řeknou:

- „Máme volný víkend.“
- „Děti jsou zdravé, mohli bychom někam vyrazit.“
- „Ve středu máme méně práce, co si prodloužit víkend?“
- „Chci najít něco hezkého, ale nechci strávit večer hledáním.“
- „Je mi jedno, jestli to bude Šumava, Beskydy, nebo Vysočina. Hlavně ať je tam dobře.“

Ne každý chce plánovat dovolenou rok dopředu. Někteří se rozhodují podle počasí, práce, rodiny, nálady – nebo prostě podle toho, že se objeví zajímavé místo. A přesně pro ně tu jsme.

## Slovo zakladatele

> Když pronajímáte chalupu, rychle zjistíte, že největší škoda nejsou jen neobsazené měsíce dopředu. Často jsou to konkrétní víkendy nebo pár dní, které se uvolní na poslední chvíli. Mně samotnému se stávalo, že hosté pobyt zrušili krátce před příjezdem – místo bylo připravené, termín volný, ale najít náhradního hosta včas bylo složité. Zároveň jsem kolem sebe viděl lidi, kteří by klidně někam jeli, kdyby rychle věděli kam. Mátevolno vzniklo právě z téhle jednoduché mezery.
>
> — Karel Mařík, zakladatel Mátevolno

## Máte volno?

Když máte pár dní volno vy i nějaké krásné místo, škoda je nechat to propadnout. Tady je pár míst, která mají volno právě teď:

::nabidky{text="Zobrazit všechny nabídky"}`,
}
